import React from 'react';
import styled from 'styled-components';
import withFilter from '@catalogo/service-americanas-product/src/questions-and-answers/hoc/filter';

const WrapperSelect = styled.div`
  position: relative;
  height: 50px;

  &:after {
    content: '';
    position: absolute;
    right: 18px;
    top: calc(50% - 6px);
    width: 7px;
    height: 7px;
    border-bottom: 2px solid #666;
    border-right: 2px solid #666;
    transform: rotate(45deg);
  }
`;

const Select = styled.select`
  width: 100%;
  height: 100%;
  padding: 15px;
  color: #666;
  background: #fff;
  border-radius: 4px;
  border: 2px solid #e9e9e9;
  appearance: none;
`;

export const OrderByComponent = ({ onChange }) => (
  <WrapperSelect>
    <Select onChange={onChange}>
      <option value="likes" default>
        ordenar por respostas mais úteis
      </option>
      <option value="descending">ordenar por mais recentes</option>
      <option value="ascending">ordenar por mais antigos</option>
    </Select>
  </WrapperSelect>
);

const OrderBy = withFilter(OrderByComponent);

export { OrderBy };
